<template>
    <div class="news mb20 b-shadow">
        <ul>
			<li class="item" v-for="item in news" :key="item.id">
				<router-link :to='{name:"detailView",params:{detail_type:"mobile",cid:item.category_id,id:item.id}}'><span><img :src="resourceUrl + item.country" alt=""></span>{{item.post_title}}</router-link>
			</li>
        </ul>
    </div>
</template>

<script>
import {resourceUrl} from '../common/util/config.js'
export default {
	props: {
		news: {
			type: Array,
			required: true
		}
	},
    data () {
        return {
        	resourceUrl
        }
    }
}
</script>
<style lang="scss">
.news{
	padding:.2rem .3rem;
	.item{
		margin-bottom: .2rem;
		&:last-child{
			margin-bottom: 0;
		}
		a{
			display: block;
			height: .45rem;
			line-height: .45rem;
			 font-size:.24rem;
			 white-space: nowrap;
			 text-overflow: ellipsis;
			 overflow: hidden;
		}
		span{
			display: inline-block;
			 width:.6rem;
			 height: .34rem;
			 margin-right: .1rem;
		}
		img{
			max-width:100%;
			max-height: 100%;
			margin-right: .2rem;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/News.vue